module.exports = __webpack_public_path__ + "static/img/home-outlined.9a1f4664.svg";